import { render, staticRenderFns } from "./AccountBalanceCard.vue?vue&type=template&id=21c7cc95&scoped=true&"
import script from "./AccountBalanceCard.vue?vue&type=script&lang=js&"
export * from "./AccountBalanceCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalanceCard.vue?vue&type=style&index=0&id=21c7cc95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7cc95",
  null
  
)

export default component.exports